/**
 * Qué escalas de "Mejorar resolución" entran en Storage —
 * ADR-2026-09-22-mejorar-imagen-4x-no-entra-en-storage.
 *
 * ⚠️ **Es un espejo de `atlas-backend/src/lib/upscaleLimits.ts`.** La copia existe
 * porque son dos repos, no porque la regla sea distinta: el backend la aplica como
 * guard duro (es el único que no se puede saltear) y el front la usa para no OFRECER
 * una escala que va a rebotar. Si cambian los números, cambian en los dos lados.
 *
 * El 22/09 el 4x de un original de 4K se tomaba 5 minutos y una llamada paga a Topaz
 * para terminar en un 413 de Storage, y el menú lo seguía ofreciendo igual.
 */

/** Techo de un objeto en Supabase Storage. Ver el módulo del backend para el porqué. */
export const STORAGE_MAX_OBJECT_BYTES = 100 * 1024 * 1024;

/** Colchón sobre el techo: la estimación es una regla de tres sobre una medición. */
const MARGEN = 0.85;

/** Bytes por píxel del PNG de Topaz. Medido: 4672x7008 pesando 35,83 MB da 1,147. */
export const PNG_BYTES_POR_PIXEL = 1.2;

export interface Dimensiones {
  width: number;
  height: number;
}

/** Las dos escalas que ofrece el producto, de mayor a menor. */
export const ESCALAS: readonly (2 | 4)[] = [4, 2];

/**
 * Cuánto pesaría el PNG de salida. El peso va con el CUADRADO de la escala: pasar de
 * 2x a 4x no duplica el archivo, lo cuadruplica.
 */
export function pesoEstimadoDelUpscale(dim: Dimensiones, scale: number): number {
  return dim.width * scale * dim.height * scale * PNG_BYTES_POR_PIXEL;
}

/** Si el resultado de esa escala tiene lugar en Storage. */
export function upscaleEntraEnStorage(dim: Dimensiones, scale: number): boolean {
  return pesoEstimadoDelUpscale(dim, scale) <= STORAGE_MAX_OBJECT_BYTES * MARGEN;
}

/** La escala más grande que entra, o `null` si no entra ninguna. */
export function mayorEscalaQueEntra(dim: Dimensiones): 2 | 4 | null {
  return ESCALAS.find((escala) => upscaleEntraEnStorage(dim, escala)) ?? null;
}
